var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletPendingDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 23C4.9 23 3.95833 22.6083 3.175 21.825C2.39167 21.0417 2 20.1 2 19V11C2 9.9 2.39167 8.95833 3.175 8.175C3.95833 7.39167 4.9 7 6 7H18C19.1 7 20.0417 7.39167 20.825 8.175C21.6083 8.95833 22 9.9 22 11V19C22 20.1 21.6083 21.0417 20.825 21.825C20.0417 22.6083 19.1 23 18 23H6ZM6 11.25H18C18.4833 11.25 18.9375 11.325 19.3625 11.475C19.7875 11.625 20.1667 11.8417 20.5 12.125V11C20.5 10.3 20.2583 9.70833 19.775 9.225C19.2917 8.74167 18.7 8.5 18 8.5H6C5.3 8.5 4.70833 8.74167 4.225 9.225C3.74167 9.70833 3.5 10.3 3.5 11V12.125C3.83333 11.8417 4.2125 11.625 4.6375 11.475C5.0625 11.325 5.51667 11.25 6 11.25ZM3.575 14.65L15.5 17.525C15.6167 17.5583 15.7375 17.5625 15.8625 17.5375C15.9875 17.5125 16.0917 17.4583 16.175 17.375L20.175 14.025C19.9583 13.6417 19.6583 13.3333 19.275 13.1C18.8917 12.8667 18.4667 12.75 18 12.75H6C5.41667 12.75 4.9 12.9292 4.45 13.2875C4 13.6458 3.70833 14.1 3.575 14.65Z",
    fill: "#282A30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 7,
    r: 5.5,
    fill: "#F39D52",
    stroke: "#F8CFAA",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPendingDark);
export default __webpack_public_path__ + "static/media/wallet_pending_dark.47e152d8917c182ca9606c4911ae8705.svg";
export { ForwardRef as ReactComponent };